let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("hTb1M"), load("5Smk7"), load("3UR1K"), load("aZ3wY"), load("joJy8"), load("aHE9G"), load("jnk96")]).then(() => parcelRequire('5bnVm'));